<template>
  <v-container fluid >
    <v-row>
      <v-col cols="12">
        <v-card >
          <v-card-title class="pb-0">
            <h2 class="display-1 ml-4">Lista help</h2>
            <v-spacer />
            <v-btn color="accent" text @click="$router.push('/helps/new')">Nuovo</v-btn>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-md >
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-text-field hide-details outlined dense v-model="titleSearch" label="Titolo" @input="applyFilter"></v-text-field>
                </v-col>
              </v-row>
              <v-row>

                <v-col cols="12">
                  <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="count"
                                :loading="tableLoading"  >

                    <template v-slot:item.title.it="{ item }">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <a @click="$router.push(`/helps/${item._id}`)" v-bind="attrs" v-on="on" class="text-decoration-underline"><b>{{ item.title.it }}</b></a>
                        </template>
                        <span>ID: {{item._id}}</span>
                      </v-tooltip>
                    </template>

                    <template v-slot:item.edit="{ item }">
                      <v-btn color="accent" dark icon v-on:click="$router.push(`/helps/${item._id}`)">
                        <v-icon dark>mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <template v-slot:item.remove="{ item }">
                      <v-btn color="error" dark icon v-on:click="requestDelete(item._id)">
                        <v-icon dark>mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import config from "../config";
export default {
  data () {
    return {
      refreshTimeout : -1,
      titleSearch : null,
      tableLoading : false,
      count : 0,
      items : [],
      headers : [
        { text : 'Ordinamento', sortable: true, align: 'left', value : 'order', width: 80 },
        { text : 'Titolo', sortable: true, align: 'left', value : 'title.it' },
        { text : 'Modifica', sortable: false, align: 'center', value : 'edit', width : 50 },
        { text : 'Elimina', sortable: false, align: 'center', value : 'remove', width : 50 },
      ],
      pagination: {},
      query : {}
    }
  },
  watch: {
    pagination: {
      handler () {
        sessionStorage.helpsPagination = JSON.stringify(this.pagination)
        clearTimeout(this.refreshTimeout);
        this.refreshTimeout = setTimeout(this.refresh, 250);
      },
      deep: true
    }
  },
  methods : {
    ...mapActions(['sendSuccess', 'sendError', 'requestConfirm', 'logout', 'load', 'remove']),

    applyFilter() {
      this.query = {};
      this.query.title = this.titleSearch ? this.titleSearch : undefined;
      this.pagination.page = 1
      sessionStorage.helpsQuery = JSON.stringify(this.query)
      clearTimeout(this.refreshTimeout);
      this.refreshTimeout = setTimeout(this.refresh, 250);
    },
    requestDelete( id ) {
      this.requestConfirm({ title : 'Richiesta conferma', message : 'Sei sicuro di cancellare questo record?', callback: ( accepted )=>{
          if(accepted) {
            this.remove({ collection : 'helps', id }).then(()=>{
              this.refresh();
              this.sendSuccess({message:'Record eliminato!'});
            }).catch((err)=>{
              let message = err.message ? err.message : "c'è stato un errore, riprova più tardi";
              this.sendError({ message });
            })

          }
        }});
    },

    refresh() {
      this.tableLoading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.pagination;
      let sort = null;
      if(sortBy.length) {
        sort = sortBy[0];
        if(sortDesc[0]) {
          sort = `-${sort}`;
        } else {
          sort = `+${sort}`;
        }
      }

      this.load({ collection : 'helps', query:this.query, limit:itemsPerPage, page : page-1, sort}).then((reply)=>{
        this.tableLoading = false;
        if(reply.data) {
          this.count = reply.count;
          this.items = reply.data;
        }
      }).catch((err)=>{
        this.tableLoading = false;
        this.sendError({message:"c'è stato un errore, riprova più tardi"});
        if(config.debug) console.error("Errore al caricamento degli utenti: " + err);
        if(err.statusCode === 401) {
          this.logout();
        }
      })
    }
  },
  mounted() {
    if(sessionStorage.helpsQuery) {
      this.query = JSON.parse(sessionStorage.helpsQuery)
      this.titleSearch = this.query.title ? this.query.title : ''
    }
    if(sessionStorage.helpsPagination) {
      this.pagination = JSON.parse(sessionStorage.helpsPagination);
    }
    this.refresh();
  }
}
</script>
